import { AnimatePresence, motion } from "framer-motion";
import { SlidersHorizontal, X } from "lucide-react";
import "./filters.css";

export default function AtlasFilterPanel({
  isOpen,
  onClose,
  onClear,
  onClearAll,
  activeCount = 0,
  children,
  title = "Filters",
  /** page = docked list page; modal = overlay inside PersonnelDetailModal */
  variant = "page",
  stackZIndex = 60,
}) {
  const handleClear = onClear || onClearAll;
  const isModal = variant === "modal";
  const panelZ = isModal ? stackZIndex : 60;
  const backdropZ = panelZ - 1;

  return (
    <AnimatePresence>
      {isOpen ? (
        <>
          <motion.div
            key="backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className={
              isModal
                ? "fixed inset-0 bg-black/25"
                : "fixed inset-0 bg-black/30 md:hidden"
            }
            style={{ zIndex: backdropZ }}
            onClick={onClose}
            aria-hidden="true"
          />

          <motion.aside
            key="panel"
            role="dialog"
            aria-modal="true"
            aria-label={title}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", duration: 0.28, ease: [0.32, 0.72, 0, 1] }}
            style={{ zIndex: panelZ }}
            className="atlas-filter-panel fixed right-0 top-0 flex h-full max-h-[100dvh] flex-col border-l border-gray-200 bg-card shadow-[-4px_0_16px_rgba(0,0,0,0.06)]"
          >
            <header className="flex shrink-0 items-center justify-between border-b border-gray-200 px-3 py-2">
              <div className="flex items-center gap-2">
                <SlidersHorizontal className="h-3.5 w-3.5 text-gray-600" strokeWidth={2} />
                <h2 className="text-xs font-semibold text-gray-800">{title}</h2>
                {activeCount > 0 ? (
                  <span className="rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium tabular-nums text-gray-600">
                    {activeCount}
                  </span>
                ) : null}
              </div>
              <button
                type="button"
                onClick={onClose}
                className="flex h-7 w-7 items-center justify-center rounded text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-800"
                aria-label="Close filters"
              >
                <X className="h-4 w-4" />
              </button>
            </header>

            <div className="atlas-filter-panel-body min-h-0 flex-1 overflow-y-auto px-3 py-2">
              <div className="space-y-2">{children}</div>
            </div>

            <footer className="shrink-0 border-t border-gray-200 bg-card px-3 py-2">
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 rounded bg-buttonRed hover:bg-buttonRed-hover text-white px-3 py-1.5 text-xs font-semibold shadow-sm transition-all duration-200 active:scale-[0.98]"
                >
                  Done
                </button>
                <button
                  type="button"
                  onClick={handleClear}
                  className="flex-1 rounded border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50 active:scale-[0.98]"
                >
                  Clear all
                </button>
              </div>
            </footer>
          </motion.aside>
        </>
      ) : null}
    </AnimatePresence>
  );
}
